import { useMediaQuery } from "hooks/use-media-query/use-media-query";
import React from "react";
import { IFreeUserLandingProps } from "./free-user-landing.types";
import { FreeUserLandingLaptop } from "./free-user-laptop";
import { FreeUserMobile } from "./free-user-mobile";

const FreeUserLanding: React.FC<IFreeUserLandingProps> = ({
  primaryUser,
  userSubscriptionStatus
}) => {
  const isLaptop = useMediaQuery("laptop");
  return isLaptop ? (
    <FreeUserLandingLaptop
      primaryUser={primaryUser}
      userSubscriptionStatus={userSubscriptionStatus}
    />
  ) : (
    <FreeUserMobile
      primaryUser={primaryUser}
      userSubscriptionStatus={userSubscriptionStatus}
    />
  );
};

export { FreeUserLanding };
